const property = require('lodash/property');

const templateUrl = require('./add-payment.html');

module.exports = function($stateProvider) {
  $stateProvider.state('billing.add', {
    resolve: {
      requiredFields: ['formsService', formsService => formsService.getRequiredFields().then(property('payment'))]
    },
    views: {
      'billing@': {
        templateUrl: templateUrl,
        controller: require('./add-payment.controller'),
        controllerAs: '$ctrl'
      }
    }
  });
};

module.exports.$inject = ['$stateProvider'];
